<template>
    <div>
        <b-card footer-class="p-0" class="rounded-lg mt-4">
            <staff-details-form v-if="settingLoaded" />
        </b-card>
    </div>
</template>

<script>
import { isEmpty } from "lodash";
import StaffDetailsForm from "@/components/setting-staff/staff-details-form.vue";

export default {
    name: "StaffNew",
    components: {
        StaffDetailsForm
    },
    computed: {
        settingLoaded() {
            return !isEmpty(this.$store.getters["setting"]);
        }
    },
    data() {
        return {};
    }
};
</script>
